import React from 'react';
import EqualHeightComponent from '@bbkPricingPage/components/equal-height-component/equal-height-component';
import Slider from '@bbkPricingPage/components/slider/slider';
import { getDefaultValueFromQuantityMeta } from '@bbkPricingPage/helpers/pricing-table-helper';
import { getFormattedNumber } from '@bbkPricingPage/lib/currencies';
import {
  QuantityMetaType,
  type QuantityMeta,
} from '@bbkPricingPage/types/pricing-table-types';

const getUom = (quantityMeta: QuantityMeta, quantity: number) => {
  if (quantity == 1) {
    return quantityMeta.unit_of_measure?.singular ?? 'unit';
  } else {
    return quantityMeta.unit_of_measure?.plural ?? 'units';
  }
};

export const QuantitySlider = ({
  id,
  quantity,
  quantityMeta,
  onValueChange,
  ignoreEqualHeight,
}: {
  id: string;
  quantity: number;
  quantityMeta?: QuantityMeta;
  onValueChange: (value: number) => void;
  ignoreEqualHeight?: boolean;
}) => {
  const defaultValue = getDefaultValueFromQuantityMeta(quantityMeta);
  return (
    <EqualHeightComponent
      groupId="dynamic-height-pricing-card-slider"
      ignore={ignoreEqualHeight}
    >
      {quantityMeta?.type === QuantityMetaType.SLIDER ? (
        <div
          className="tw-flex tw-w-full tw-flex-col tw-items-center tw-py-2 @md:tw-py-2"
          id={`item-slider-${id}`}
        >
          <div className="tw-flex tw-w-full tw-justify-center tw-py-6 @md:tw-py-2">
            <Slider
              min={quantityMeta.min}
              max={quantityMeta.max}
              step={quantityMeta.step}
              value={quantity}
              defaultValue={defaultValue}
              onValueChange={onValueChange}
            />
          </div>
          <div className="tw-font-semibold tw-text-[var(--pricing-page-text-font-text-color)]">
            {`${getFormattedNumber(quantity)} ${getUom(quantityMeta, quantity)}`}
          </div>
        </div>
      ) : (
        <></>
      )}
    </EqualHeightComponent>
  );
};
